<div class="input-group">
  <input class="form-control" readonly="true" [(ngModel)]="value" (ngModelChange)="modelChanged($event)" [matDatepicker]="picker" />
  @if (showClear) {
    <button class="btn btn-light" (click)="clear()" type="button">
      <fa-icon [icon]="faRotateLeft" [fixedWidth]="true"></fa-icon>
    </button>
  }
  <button class="btn btn-light" (click)="picker.open()" type="button">
    <fa-icon [icon]="faCalendarDays" [fixedWidth]="true"></fa-icon>
  </button>
</div>
<mat-datepicker #picker></mat-datepicker>
